import React, { useState } from 'react';
import { Download, Check, ChevronDown } from 'lucide-react';

const SimpleExportMenu = ({ signatureTemplate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [exportStatus, setExportStatus] = useState('');
  
  // Convertir la signature en texte brut
  const getPlainTextSignature = () => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = signatureTemplate;
    return tempDiv.innerText;
  };

  // Fonction pour télécharger le fichier
  const downloadFile = (content, filename, type) => {
    const blob = new Blob([content], { type: `text/${type}` });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleExport = (format) => {
    try {
      switch (format) {
        case 'html':
          downloadFile(signatureTemplate, 'signature.html', 'html');
          setExportStatus('HTML exporté avec succès');
          break;
        case 'txt':
          downloadFile(getPlainTextSignature(), 'signature.txt', 'plain');
          setExportStatus('Texte exporté avec succès');
          break;
        default:
          throw new Error('Format non supporté');
      }
      
      setIsOpen(false);
      
      // Réinitialiser le message de statut après 2 secondes
      setTimeout(() => setExportStatus(''), 2000);
    } catch (error) {
      setExportStatus('Erreur lors de l\'export');
      setTimeout(() => setExportStatus(''), 2000);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex-1 flex items-center justify-center space-x-2 bg-gray-600 text-white py-3 px-4 rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
      >
        <Download className="w-5 h-5" />
        <span>Exporter</span>
        <ChevronDown className="w-4 h-4 ml-2" />
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10">
          <div className="py-1">
            <button
              onClick={() => handleExport('html')}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Format HTML
            </button>
            <button
              onClick={() => handleExport('txt')}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Format Texte
            </button>
          </div>
        </div>
      )}
      
      {exportStatus && (
        <div className="absolute top-0 right-0 mt-16 flex items-center bg-green-100 text-green-600 px-3 py-1 rounded">
          <Check className="w-4 h-4 mr-1" />
          <span className="text-sm">{exportStatus}</span>
        </div>
      )}
    </div>
  );
};

export default SimpleExportMenu;
